export default function query(selector, { all = false } = {}) {
  return (target, key, descriptor) => {
    delete descriptor.writable;
    delete descriptor.initializer;
    descriptor.get = function getter() {
      if (all) {
        return this.renderRoot.querySelectorAll(selector);
      }
      return this.renderRoot.querySelector(selector);
    };
    return descriptor;
  };
}
